import { Component } from "@angular/core";

@Component({
  selector: "app-public-footer",
  standalone: true,
  imports: [],
  templateUrl: "./public-footer.component.html",
})
export class PublicFooterComponent {}
